<template>
      <v-layout row wrap justify-center align-center>
          <v-flex xs12>
              <v-card>
                  <v-card-title>
                    <v-layout row wrap align-end>
                    <v-flex>
                      <h1> Busca de Unidades </h1>
                      <v-spacer></v-spacer>
                    </v-flex>
                    <v-flex>
                       <v-text-field
                        append-icon="search"
                        single-line
                        hide-details
                        v-model="search"
                    ></v-text-field>
                    </v-flex>
                    </v-layout>

                  </v-card-title>
                  <v-card-text>
                      <v-container> 
                        <!-- MakerLab -->
                      <v-layout row v-if="isMakerlab">
                          <v-flex xs-8>
                        <v-data-table
                        :headers="headersLab"
                        :items="rows"
                        :loading="animation"
                        :search="search"
                        >
                        <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
                        <template slot="items" slot-scope="props">
                          <td @click="gotoProject(props.item)">{{ props.item.name }}</td>
                          <td @click="gotoProject(props.item)">{{ props.item.logradouro}}</td>                          
                        </template>
                        <v-alert slot="no-results" :value="true" color="error" icon="warning">
                            Sua busca por "{{ search }}" não encontrou resultados.
                        </v-alert>
                        <template v-if="mensagem" slot="no-data">
                            Ops... Nenhum dado no momento
                        </template>
                        <template v-if="!mensagem" slot="no-data">
                            Carregando os dados
                        </template>
                        </v-data-table>
                          </v-flex>

                      </v-layout>
                        <!-- MundoMaker -->
                      <v-layout row v-else>
                          <v-flex xs-8>
                        <v-data-table
                        :headers="headers"
                        :items="rows"
                        :loading="animation"
                        :search="search"
                        >
                        <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
                        <template slot="items" slot-scope="props">
                          <td @click="gotoProject(props.item)">{{ props.item.name }}</td>
                          <td @click="gotoProject(props.item)">{{ props.item.logradouro}}</td>
                          <td @click="gotoProject(props.item)">{{ props.item.companies }}</td>   
                          <td @click="gotoProject(props.item)">{{ props.item.responsavel }}</td>                            
                        </template>
                        <v-alert slot="no-results" :value="true" color="error" icon="warning">
                            Sua busca por "{{ search }}" não encontrou resultados.
                        </v-alert>
                        <template v-if="mensagem" slot="no-data">
                            Ops... Nenhum dado no momento
                        </template>
                        <template v-if="!mensagem" slot="no-data">
                            Carregando os dados
                        </template>
                        </v-data-table>
                          </v-flex>

                      </v-layout>
                      </v-container>
                  </v-card-text>
              </v-card>
          </v-flex>
      </v-layout>
</template>

<script>
import api from '@/api'

export default {
  data () {
    return {
      search: '',
      animation: true,
      mensagem: false,
      company: [],
      headers: [
        { text: 'Nome', value: 'name' },
        { text: 'Local', value: 'logradouro' },
        { text: 'Empresa', value: 'companies' },
        { text: 'Responsável', value: 'companies' }
      ],
      headersLab: [
        { text: 'Nome', value: 'name' },
        { text: 'Local', value: 'logradouro' }
      ],
      rows: []
    }
  },
  methods: {
    gotoProject (row) {
      this.$router.push(
        {name: 'unidade-detail',
          params: {'slug': row.slug}
        })
    }
  },
  mounted () {
    api.request('GET', 'companies/').then(resp => {
      this.company = resp.data
      api.request('GET', 'unidade/').then(response => {
        var arr = response.data.map(data => {
          let companies
          if (data.company) {
            companies = this.company.find(e => e.id === data.company)
            companies = companies.name
          }
          return {
            name: data.name,
            slug: data.slug,
            phonenumber: data.phonenumber,
            logradouro: data.logradouro,
            companies: companies,
            responsavel: data.responsavel
          }
        })
        console.log('arr', arr)
        this.rows = arr
        this.animation = false
        this.mensagem = true
      })
    })
  },
  computed: {
    isMakerlab () {
      return this.$store.state.company.makerlab;
    }
  }
}
</script>

<style lang="scss" scoped>

td:hover{
  cursor: pointer; 
  }

</style>



// WEBPACK FOOTER //
// src/components/pages/Unidades/Search.vue